import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import logo from "../assets/logo.png"

function Index() {
  return (
    <div id="homepage">
      <img className="logo homepage" src={logo} alt='Cadavre Exquis'/>
      <div id="description">
        <p>Cadavre Exquis is a collaborative animation where each frame is drawn by a different person.</p>
        <p>To take part, you will be shown the latest three frames of the animation and will be asked to come up with the next one.</p>
        <p>It is only once you submit your contribution that the whole animation will be revealed to you.</p>
      </div>
      <a id="launch-button" className='button' href="/app">Launch <FontAwesomeIcon icon={faArrowRight} className="right-arrow" /></a>
    </div>
  )
}

export default Index